import apply from './main/apply';
import applied from './main/applied';
import reception from './main/reception';
import template from './main/template';

const main = [
  {
    path: '/apply',
    component: () => import('@/mobile/page/apply'),
    redirect: '/apply/vacation',
    children: [...apply],
    meta: {
      name: '신규 결재 신청',
    },
  },
  {
    path: '/applied',
    component: () => import('@/mobile/page/applied'),
    children: [...applied],
    meta: {
      name: '결재신청함',
    },
  },
  {
    path: '/reception',
    name: 'receptionList',
    component: () => import('@/mobile/page/reception'),
    children: [...reception],
    meta: {
      name: '결재수신함',
    },
  },
  {
    path: '/notice',
    component: () => import('@/mobile/page/notice'),
    children: [
      {
        path: '/notice/:id',
        name: 'NoticeDetails',
        component: () => import('@/mobile/page/notice/detail'),
        meta: {
          name: '공지사항 상세',
        },
      },
    ],
    meta: {
      name: '공지사항',
    },
  },
  {
    path: '/contact',
    component: () => import('@/mobile/page/contact'),
    meta: {
      name: '비상연락망',
    },
  },
];

if (process.env.VUE_APP_ENVIRONMENT === 'local') {
  main.push(...template);
}

export default main;
